import { NgModule } from "@angular/core";
import { GridComponent } from "./grid.component";

@NgModule({
  declarations: [GridComponent],
  imports: [],
  exports: [GridComponent],
})
export class BkUiGridModule { }
